import { JSX, ReactNode } from "react";
import { cn } from "@/utils/helpers";
import styles from "../Columns.module.css";

export interface ColumnProps {
	size?: number;
	title?: string | ReactNode;
	titleTag?: string;
	children?: ReactNode;
	className?: string;
};

export default function Column({
	size = 6,
	title,
	titleTag = "h3",
	children,
	className
} : ColumnProps) {

	const TitleTag = titleTag as keyof JSX.IntrinsicElements;
	
	return (
		<div
			className={cn(
				styles.Column,
				styles[`Column_${size}`],
				className
			)}
		>
			{title && TitleTag ?
				<TitleTag
					className={styles.ColumnTitle}
				>
					<span>{title}</span>
				</TitleTag>
			: null}
			<div
				className={styles.ColumnBody}
			>
				{children}
			</div>
		</div>
	);
};